// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"22a53ada","894":"8739e7b1"}[chunkId] + ".chunk.js";
};